// docs: https://github.com/altostra/type-validations#readme
import { objectOf, recordOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCreateLocationSetResult = objectOf({
  id: string,
  geofence_local_id_to_created_id: recordOf(string),
});
